import { readZustandLocalStorage } from './readZustandLocalStorage'
import { deepRemoveKeysByPaths } from '../storeUtils'
import { playerStoreInitialValues, playerStoreKey } from '../playerStore/playerStoreConstants'
import { casinoStoreInitialValues, casinoStoreKey } from '../casinoStore/casinoStoreConstants'
import {
  storeInitialState,
  zustandLocalStorageName,
  zustandLocalStorageVersion,
  excludedPlayerDataFromLocalStorage,
  excludedCasinoDataFromLocalStorage
} from '../storeConstants'
import { migrateLocalStorage } from './migrateLocalStorage'

export const updateZustandLocalStorage = (storeKey, data, versionCheck = false) => {
  const zustandLocalStorageDefaultData = {
    [playerStoreKey]: playerStoreInitialValues,
    [casinoStoreKey]: casinoStoreInitialValues
  }

  let zustandLocalStorageData = readZustandLocalStorage()
  let newZustandLocalStorageData = zustandLocalStorageDefaultData

  if (zustandLocalStorageData) {
    if (zustandLocalStorageVersion() !== zustandLocalStorageData.version && versionCheck) {
      zustandLocalStorageData = migrateLocalStorage(storeInitialState, zustandLocalStorageData)
    }

    try {
      if (versionCheck) {
        newZustandLocalStorageData = { ...zustandLocalStorageData, version: zustandLocalStorageVersion() }
      } else {
        newZustandLocalStorageData = { ...newZustandLocalStorageData, ...zustandLocalStorageData, [storeKey]: data }
      }

      // player data excluding
      newZustandLocalStorageData[playerStoreKey] = deepRemoveKeysByPaths(
        newZustandLocalStorageData[playerStoreKey],
        excludedPlayerDataFromLocalStorage
      )

      // casino data excluding
      newZustandLocalStorageData[casinoStoreKey] = deepRemoveKeysByPaths(
        newZustandLocalStorageData[casinoStoreKey],
        excludedCasinoDataFromLocalStorage
      )

      localStorage.setItem(zustandLocalStorageName, JSON.stringify(newZustandLocalStorageData))
    } catch (e) {
      console.log('Zustand local storage updating error: ', e)
    }
  } else {
    localStorage.setItem(zustandLocalStorageName, JSON.stringify(zustandLocalStorageDefaultData))

    updateZustandLocalStorage(storeKey, data, versionCheck)
  }

  return newZustandLocalStorageData
}
